import React from 'react';
import PageHeader from '../../components/PageHeader';
import { BRAND_NAME } from '../../utils/brand';

function LabRelease() {
  return (
    <>
      <PageHeader title="Lab Result Release Consent" subtitle="Section 13.4 — Outcome tracking" />
      <div className="card prose">
        <p><strong>I authorize the following:</strong></p>
        <ul>
          <li>
            Clinics and laboratories I have engaged through {BRAND_NAME} may
            release my test results (including HbA1c, liver function,
            kidney function, and lipid profile panels) to {BRAND_NAME} for
            tracking and analysis purposes.
          </li>
          <li>
            {BRAND_NAME} may use these results in aggregated, de-identified
            form for outcome research and clinic performance metrics.
          </li>
          <li>
            Identifiable results will only be visible to me, the assigned
            clinic, and authorized {BRAND_NAME} staff bound by confidentiality
            obligations.
          </li>
          <li>
            I understand I may revoke this consent for future releases at
            any time by contacting support.
          </li>
        </ul>
      </div>
    </>
  );
}

export default LabRelease;
